import React from 'react';
import './ConfirmDialog.css';

const ConfirmDialog = ({ message, onConfirm, onCancel, loading }) => {
    return (
        <div className="confirm-dialog-backdrop">
            <div className="confirm-dialog">
                <p className="confirm-message">{message}</p>
                <div className="confirm-actions">
                    <button className="btn cancel" onClick={onCancel}>Cancel</button>
                    <button className="btn confirm" onClick={onConfirm} disabled={loading}>
                        {loading ? 'Please wait...' : 'Confirm'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;